var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"margin-top":"-45px","margin-left":"-30px"},attrs:{"href":"#","alt":"logo","src":_vm.imgurl}})}
var staticRenderFns = []

export { render, staticRenderFns }